export default "__VITE_ASSET__ymcp0LVw__"